var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { STRIPE_KEY } from "src/app/config";
let _stripePromiseInstance = null;
function loadStripe() {
    if (!_stripePromiseInstance) {
        _stripePromiseInstance = new Promise((resolve) => {
            if (window.Stripe) {
                resolve(window.Stripe(STRIPE_KEY));
            }
            else {
                const script = document.createElement("script");
                script.src = "https://js.stripe.com/v3/";
                script.async = true;
                script.onload = () => {
                    if (window.Stripe) {
                        resolve(window.Stripe(STRIPE_KEY));
                    }
                    else {
                        resolve(null);
                    }
                };
                script.onerror = () => resolve(null);
                document.body.appendChild(script);
            }
        });
    }
    return _stripePromiseInstance;
}
export const stripePromise = loadStripe();
const stripe = {
    redirectToCheckout: ({ sessionId }) => __awaiter(void 0, void 0, void 0, function* () {
        const stripeInstance = yield stripePromise;
        if (!stripeInstance)
            return;
        return stripeInstance.redirectToCheckout({ sessionId });
    })
};
export default stripe;
